// Email format used across the journey and Loan Summary (applicant, co-applicant,
// reference). "+" and "-" are not allowed anywhere; dots only between characters.
export const JOURNEY_EMAIL_REGEX =
  /^[A-Za-z0-9_]+(\.[A-Za-z0-9_]+)*@[A-Za-z0-9]+(\.[A-Za-z0-9]+)*\.[A-Za-z]{2,}$/;

export const JOURNEY_EMAIL_ERROR =
  "Please enter a valid email address (e.g., name@example.com).";

export const isValidJourneyEmail = (value: any) =>
  JOURNEY_EMAIL_REGEX.test(String(value ?? "").trim());

// Email input fields (e.g. email, basicCoApplicant1Email, basicReference1EmailID),
// not the verification flags (isEmailVerified, basicCoApplicant1IsEmailVerified)
export const isEmailFieldName = (name: any) =>
  /email(id)?$/i.test(String(name ?? "").trim()) && !/verified/i.test(String(name ?? ""));
